export default __webpack_public_path__ + "static/media/sliderIndicatorLight.072521ac.svg";